<template>
    <div class="page-wrapper" v-bind:class="{'page-short': !defaultPage}">
        <dialog/>
        <tooltip />
        <div class="left-panel">
            <div class="brand-container">
                <div class="wrapper">
                    <div class="logo">
                        <router-link :to="{ name: getHomeName() }">
                            <div class="logo-img"></div>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="wrapper section-nav">

                <div class="none-space"></div>

                <i18n></i18n>

                <support></support>

                <br />

                <ul class="menu-wrapper">
                    <li v-for="item in getMenu()">
                        <router-link :class="item.type" :to="{ name: item.name }" v-popover:tooltip.right="t(item.title)" exact>
                            <span v-if="item.iconClass" v-bind:class="item.iconClass"></span>
<!--                            <div class="ico-report" v-bind:class="['ico', item.ico ? item.ico : 'ico-reports']"></div>&nbsp;-->
                            <span class="pd"> {{ t(item.label) }}</span>
                        </router-link>
                    </li>
                </ul>

                <hr />

                <div style="position:relative;bottom:0;padding-left:5px;">
                    <a href="#" @click="toggleMenu" id="toggle-menu" class="ico ico-toggle-right" v-bind:class="{'ico-toggle-left': defaultPage}">&nbsp;</a>
                </div>
            </div>
        </div>
        <div class="right-column">


            <div class="navbar navbar-default" v-if="isLogged">
                <ul class="nav navbar-nav navbar-left">
                    <li v-if="projectMetadata.showAppointmentButton">
                        <div>
                            <button class="btn navbar-button">
                                <a :href="projectMetadata.appointmentLink" target="_blank">
                                    <span class="icon icon-meeting navbar-button-icon"></span>
                                    <span class="navbar-button-text">{{ t('Make an appointment') }}</span>
                                </a>
                            </button>
                        </div>
                    </li>
                    <li v-if="projectMetadata.showTutorialButton">
                        <div>
                            <button class="btn navbar-button" @click="showTutorialModal">
                                <span class="icon icon-video-player navbar-button-icon"></span>
                                <span class="navbar-button-text">{{ t('Watch the tutorial video') }}</span>
                            </button>
                        </div>
                    </li>
                </ul>
                <ul class="nav navbar-nav navbar-right">
                    <li v-for="item in getUserMenu()">
                        <router-link :to="{ name: item.name }" v-popover:tooltip="t(item.label)" exact>
                            <span v-if="item.iconClass" v-bind:class="item.iconClass"></span>
                            <span class="pd"> {{ t(item.label) }}</span>
                        </router-link>
                    </li>
                    <li>
                        {{ getUserName() }} {{ getExpiredDays() }}
                    </li>
                    <li>
                        <a href="#" @click="openNotifications()" v-bind:class="{'notify': newNotifications}"
                           class="ico ico-info"><span v-show="newNotifications"></span>&nbsp;</a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="logout" v-popover:tooltip="t('Logout')" class="ico ico-off">&nbsp;</a>
                    </li>
                </ul>

            </div>

            <div class="wrapper">
                <v-dialog/>
                <vue-confirm-dialog></vue-confirm-dialog>
                <div class="primary-content">
                    <router-view :key="$route.path"></router-view>
                </div>
            </div>
        </div>

        <div class="notifications" v-show="notificationsPanelOpened">
            <div class="head">
                <div class="wrapper clearfix">
                    <h4>{{ t('Notifications') }} <a @click="closeNotifications()" class="ico ico-close close">&nbsp;</a></h4>
                </div>
            </div>

            <notification-panel :existsNew="newNotifications" :opened="notificationsPanelOpened"></notification-panel>
        </div>
        <ModalFactory>
        </ModalFactory>
    </div>

</template>

<script>
    import Vue from 'vue'
    import {auth, notifications} from './../services'
    import NotificationPanel from '../components/NotificationPanel.vue'
    import i18n from '../components/I18n.vue';
    import Support from '../components/Support'
    import router from "../router";
    import ValueChecker from "../services/ValueChecker";
    import ModalFactory from "../components/modal/ModalFactory.vue";
    import TutorialModal from "@/components/modal/type/TutorialModal.vue";
    import FirstLoginModal from "@/components/modal/type/FirstLoginModal.vue";
    let logoutTimeout;
    import VPopover from 'vue-js-popover'
    Vue.use(VPopover, { tooltip: true })

    const DEFAULT_TEMPLATE = 'light';

    function idleLogout() {
        clearTimeout(logoutTimeout);
        logoutTimeout = setTimeout(() => {
            auth.logout();
            window.location = '/';
        }, 10 * 60 * 1000)
    }

    export default {
        data() {
            return {
                menu: [],
                userMenu: [],
                userMetadata: [],
                projectMetadata: [],
                support:
                {
                    options: {
                        bug: 'Błąd',
                        extenstion: "Rozszeżenie",
                        question: "Pytanie"
                    },
                    type: 'bug',
                },
                defaultPage: true,
                isLogged: auth.isLogged(),
                notificationsPanelOpened: false,
                newNotifications: false,
            }
        },
        components: {
            ModalFactory,
            NotificationPanel,
            i18n,
            Support
        },
        computed: {
            showOverlay() {
                return false //this.$store.state.overlayShown
            }
        },
        inject: ['componentService'],
        mounted()
        {
            this.$root.$on('menu-ready', (menu) => {
                this.menu = menu;
            });
            this.$root.$on('user-menu-ready', (userMenu) => {
                this.userMenu = userMenu;
            });
            this.$root.$on('user-metadata-ready', (userMetadata) => {
                this.userMetadata = userMetadata;

                if (this.projectMetadata.showFirstLoginModal && userMetadata['isFirstLogin']) {
                    this.showFirstLoginModal();
                }
            });
            this.$root.$on('project-metadata-ready', (data) => {
                this.projectMetadata = data;
            });
            this.$root.$on('show-component-in-modal', (config, eventData) => {
                let componentMetadata = this.componentService.get(config.componentIndex);
                let componentType = componentMetadata.getType();
                let componentConfig = componentMetadata.getComponentConfig();

                componentConfig['index'] = config.componentIndex;

                let component = this.loadComponent(componentType);

                let modalConfig = {
                    title: config.title || null,
                    style: config.style || {}
                };

                this.$root.$emit('openModal', component, modalConfig, componentConfig, eventData);
            });

            if (auth.isAutoLogout()) {
                document.addEventListener('click', idleLogout);
            }
        },
        watch: {
            // call again the method if the route changes
            '$route': 'changeTemplate',
        },
        methods:
        {
            loadComponent(componentName) {
                return require(`./../components/${componentName}.vue`);
            },
            showFirstLoginModal() {
                this.$root.$emit('openModal', FirstLoginModal, {title: 'Welcome in Brandly360!'});
            },
            showTutorialModal() {
                this.$root.$emit('openModal', TutorialModal, {title: 'Check how to easy use our panel'});
            },
            changeTemplate()
            {
                let newTemplate = null;

                if (typeof this.$route.meta.template !== 'undefined') {
                    newTemplate = this.$route.meta.template;
                }

                document.body.classList.remove(DEFAULT_TEMPLATE);
                document.body.classList.remove('light');

                if (!newTemplate) {
                    document.body.classList.add(DEFAULT_TEMPLATE);
                }

                if (newTemplate) {
                    document.body.classList.add(newTemplate);
                }
            },
            toggleSupport() {
                this.$modal.show('support');
            },
            checkNewNotifications() {
                if (!this.notificationsPanelOpened) {
                    this.$http.get('notifications/check', {showProgressBar: false}).then((response) => {
                        if (response.body.count > 0) {
                            this.newNotifications = response.body.count;
                        }
                    });
                }
            },
            openNotifications() {
                this.notificationsPanelOpened = true;
                this.newNotifications = false;
            },
            closeNotifications() {
                this.notificationsPanelOpened = false;
            },

            toggleMenu() {
                this.defaultPage = !this.defaultPage;
                this.$root.$emit('Dashboard:toggleMenu')
            },
            getHomeName() {
                return router.getHomeName();
            },
            getMenu() {
                return this.menu;
            },
            getUserMenu() {
                return this.userMenu;
            },
            getUserName() {
                if (!this.userMetadata) {
                    return '';
                }

                return `${this.userMetadata.email}`;
            },
            getExpiredDays() {
                if (!this.userMetadata || ValueChecker.isUndefinedOrNull(this.userMetadata.expiredInDays)) {
                    return '';
                }

                let daysLeftText = this.$trans(`%days% days left`, {days: this.userMetadata.expiredInDays});

                return `(${daysLeftText})`;
            },
            logout() {
                auth.logout(this, function () {
                    window.location.href = router.getSignInLink();
                });
            },
        }
    }
</script>

<style lang="sass" scoped>
@import "src/assets/scss/variable.scss";
    .support{
        color:black;

        .v--modal-box{
            height:auto;
        }
    }
    .pd {
        display: block;
        margin-left: 20px;

        &::first-letter {
          text-transform: uppercase;
        }
    }

    .share {
        opacity: 0.5;
        pointer-events: none;
    }

    .navbar-button {
        background-color: white!important;
        color: #4baf4d;
        margin: 15px;
    }

    .navbar-button:hover {
        opacity: 0.9;
    }

    .navbar-button-icon {
        background-color: $main-background-color!important;
        margin-bottom: -6px;
    }

    .navbar-button-text {
        padding-left: 5px;
        color: #4baf4d!important;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?522f8564